import React, { useEffect, useState } from 'react'
// import Footer from './components/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import Footer from '../components/Footer';

function ManageFunds() {
    const [email, setEmail] = useState("");
    const [amountSecond, setAmountSecond] = useState("");
    const navigate = useNavigate()
    const apiKey = process.env.REACT_APP_API_KEY;
    const auth = getAuth()
    const [amount, setAmount] = useState('');
    const [userId, setUserId] = useState('');




    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/sign-in');
            } else {
                setUserId(user.uid); // Get authenticated user ID
            }
        });

        return () => unsubscribe();
    }, [auth, navigate]);

    const handleTopUp = async () => {
        if (!userId) {
            Swal.fire('Error', 'User not authenticated', 'error');
            return;
        }

        try {
            const response = await axios.post(
                'https://api.v1.spotyourleads.com/user/topup',
                {
                    amount: Number(amount),
                    userId: userId,
                },
                {
                    headers: {
                        'x-api-key': apiKey
                    }
                }
            );

            if (response.status === 200 && response.data.url) {
                window.location.href = response.data.url;
            } else {
                Swal.fire('Error', 'Failed to top up wallet', 'error');
            }
        } catch (error) {
            Swal.fire('Error', error.response?.data?.message || 'An error occurred', 'error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !amountSecond) {
            Swal.fire('Error', 'Please enter a valid email and amount.', 'error');
            return;
        }

        Swal.fire({
            title: "Are you sure?",
            text: `Do You agree to transfer $${amountSecond} to ${email} ? `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Transfer!",
            cancelButtonText: "Cancel",
            customClass: {
                confirmButton: "swal-confirm-btn",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const payload = {
                    amount: parseFloat(amountSecond),
                    userId: userId,
                    email,
                };

                try {
                    const response = await fetch("https://api.v1.spotyourleads.com/user/transfer", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "x-api-key": apiKey,
                        },
                        body: JSON.stringify(payload),
                    });

                    const data = await response.json();

                    if (response.ok) {
                        Swal.fire({
                            title: "Success",
                            text: data?.message || "Funds transferred successfully!",
                            icon: "success",
                            timer: 2000,
                            showConfirmButton: false
                        });
                        setAmountSecond(0)
                        setEmail("")
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: data?.message || "An error occurred",
                            icon: "error",
                            timer: 2000,
                            showConfirmButton: false
                        });

                    }
                } catch (error) {
                    Swal.fire({
                        title: "Error",
                        text: error?.message || "An error occurred",
                        icon: "error",
                        timer: 2000,
                        showConfirmButton: false
                    });

                }
            }
        });
    };

    return (
        <>
             <Helmet>
                <title>Spot Your Leads |  Top Up Your Account for More Leads </title>
              </Helmet>
        
            <section className='manage-funds'>
                <div className='pricing-title'>
                    <h2>Manage Funds</h2>

                </div>
                <Container>
                    <Row>
                        <Col lg={6} md={6} sm={12}>

                            <div className='addFunds'>
                                <h5>Add Funds</h5>
                                <div className='funds-input'>

                                    <input name="funds"
                                        min={0}
                                        type="number"
                                        value={amount}
                                        onChange={(e) => setAmount(e.target.value)} />
                                    <div>
                                        <img src="images/$.svg" alt="" />
                                    </div>
                                </div>
                                <button onClick={handleTopUp} style={{marginTop:"125px"}}>Confirm</button>
                                <p className='price-note'>
                                Your Wallet are your ticket to unlocking exclusive leads. Top up now and never miss an opportunity.


                                </p>
                            </div>

                        </Col>
                        <Col lg={6} md={6} sm={12}>
                            <form className="addFunds" onSubmit={handleSubmit}>
                                <h5>Transfer Funds</h5>
                                <div className='funds-input'>

                                    <input
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        name="email" type='email' placeholder='Email Address' />

                                </div>
                                <div className='funds-input'>

                                    <input name="funds" placeholder='Amount' type="number"
                                        value={amountSecond}
                                        onChange={(e) => setAmountSecond(e.target.value)} />
                                    <div>
                                        <img src="images/$.svg" alt="" />
                                    </div>
                                </div>
                                <button type="submit">Confirm</button>
                                <p className='price-note'>
                                Now you can transfer your funds between registered users by entering the email they registered with along with the amount, please beware that once the transfer is complete it cannot be reverted
                                </p>
                            </form>

                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
        </>
    )
}

export default ManageFunds
